module.exports = __webpack_public_path__ + "static/img/pupil--small.84d2514.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school-grounds/pupil--small.svg
// module id = 173
// module chunks = 2